var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Hero'),_c('div',{staticClass:"pt-6"},_vm._l((_vm.taxons_filtered),function(taxon){return _c('Taxon',{key:taxon.id,attrs:{"taxon":taxon}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }